import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, ExternalLink } from 'lucide-react';
import PageShell from '@/components/PageShell';
import SEO from '@/components/SEO';
import { useLanguage } from '@/i18n/LanguageContext';
import { HOW_BAIL_WORKS_STEPS, MCSO_JAIL } from '@/data/siteContent';
import { track } from '@/lib/analytics';

const HowBailWorks = () => {
  const { lang, t } = useLanguage();
  return (
    <PageShell trackPage="/how-bail-works">
      <SEO title="How Bail Works in Montgomery County, TX | Amigo's Bail Bonds" description="A clear, verified walkthrough of the booking-to-release bail process at the Montgomery County Jail in Conroe, Texas." path="/how-bail-works" />
      <div className="page-hero">
        <div className="eyebrow">{lang === 'es' ? 'GUÍA VERIFICADA' : 'VERIFIED PROCESS GUIDE'}</div>
        <h1 className="section-title">{lang === 'es' ? 'CÓMO FUNCIONA LA FIANZA' : 'HOW BAIL WORKS'}</h1>
        <p className="section-subtitle" style={{ margin: '0 auto' }}>{lang === 'es' ? 'Basado en información pública de la Oficina del Sheriff del Condado de Montgomery.' : "Based on public information from the Montgomery County Sheriff's Office."}</p>
      </div>

      <section className="section section--void">
        <div className="container" style={{ maxWidth: 860 }}>
          <div className="timeline">
            {HOW_BAIL_WORKS_STEPS.map((s, i) => (
              <div className="timeline-item" key={i} data-testid={`process-step-${i}`}>
                <span className="badge badge-gold mb-2">{lang === 'es' ? 'PASO' : 'STEP'} {i + 1}</span>
                <h3 style={{ color: 'var(--text-primary)', fontFamily: 'var(--font-alt)', fontSize: '1.15rem', margin: '0.3rem 0 0.5rem' }}>{s[lang].title}</h3>
                <p style={{ color: 'var(--text-secondary)', lineHeight: 1.7 }}>{s[lang].text}</p>
              </div>
            ))}
          </div>

          <div className="info-card mt-8">
            <h3 style={{ color: 'var(--text-primary)', margin: '0 0 0.6rem' }}>{lang === 'es' ? 'Recursos oficiales del condado' : 'Official county resources'}</h3>
            <p style={{ color: 'var(--text-secondary)', marginBottom: '0.8rem' }}>{MCSO_JAIL.name} — {MCSO_JAIL.address}</p>
            <div className="flex gap-4" style={{ flexWrap: 'wrap' }}>
              <a href={MCSO_JAIL.inmateSearchUrl} target="_blank" rel="noopener noreferrer" className="btn-brass" onClick={() => track('jail_lookup_click', { location: 'how_bail_works' })} data-testid="official-inmate-search-link">
                {t('common.locateInmate')} <ExternalLink size={14} />
              </a>
              <a href={`tel:${MCSO_JAIL.infoLine.replace(/\D/g, '')}`} className="btn-ghost-dark" data-testid="jail-info-line-link"><Phone size={14} /> Jail Info Line: {MCSO_JAIL.infoLine}</a>
            </div>
          </div>

          <div className="text-center mt-8">
            <Link to="/start-a-bond" className="btn-red" data-testid="how-bail-cta">{t('hero.startBond')}</Link>
          </div>
        </div>
      </section>
    </PageShell>
  );
};

export default HowBailWorks;
